export const getStepStyles = (components, { palette = {} } = {}) => {
  const color = {
    advancedTitleColor: palette.blue || '#0078D4',
    errorAlertColor: '#a4262c',
  };
  const commonFont = {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
  };
  const titleFont = {
    fontSize: 18,
    fontWeight: 400,
  };
  const subTitleFont = {
    fontSize: 14,
    fontWeight: 600,
  };
  const plainTextFont = {
    fontSize: 14,
    fontWeight: 400,
  };
  return ({
    contentBlock: {
      marginLeft: '26px',
      overflowX: 'hidden',
      overflowY: 'hidden',

      '& .btn-link': {
        color: '#0078d4',
        textDecoration: 'underline',
      },

      '& .tagConfirmationText': {
        marginLeft: '25px',
      },

      '& .alert': {
        border: 'none',
        boxShadow: 'none',
        fontSize: '12px',
        fontWeight: 400,
        color: '#323130',
        display: 'flex',
        height: 'auto',
        lineHeight: '16px',
        padding: '8px 32px 8px 8px',
        verticalAlign: 'middle',
      },
      '& .alert-info': {
        backgroundColor: '#eff6fc',
        borderColor: '#eff6fc',
        color: '#323130',

        '& .alert-image:before': {
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '16px',
          lineHeight: '16px',
          color: '#605e5c',
          marginRight: '8px',
          content: '\'\\E946\'',
        },
      },
      '& .alert-warning': {
        backgroundColor: '#fff4ce',
        borderColor: '#fff4ce',
        color: '#323130',

        '& .alert-image:before': {
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '16px',
          lineHeight: '16px',
          color: '#d83b01',
          marginRight: '8px',
          content: '\'\\E7BA\'',
        },
      },
    },
    scrollableContainer: {
      overflowX: 'auto',
    },
    instructionsHeader: {
      marginBottom: '7px',
    },
    buttonBlock: {
      '& *:not(:last-child)': {
        marginRight: '15px',
      },
    },
    loading: {
      backgroundColor: palette.white,
      paddingTop: '6px',
      paddingBottom: '6px',
      height: '100%',
    },
    radioButtonsBlock: {
      '& .ms-ChoiceFieldGroup': {
        '& label': {
          lineHeight: '12px',
          fontWeight: 400,
        },
      },
    },
    helpButton: {
      marginLeft: 5,
    },
    sendEmailsTextbox: {
      width: 268,
    },
    dropdownAddIcon: {
      fontSize: '16px',
      color: color.advancedTitleColor,
      marginRight: '5px',
      verticalAlign: 'bottom',
      fontWeight: 'bold',
    },
    eventParamRemoveIcon: {
      fontSize: '24px',
      verticalAlign: 'middle',
      cursor: 'pointer',
    },
    section: {
      marginBottom: 30,
      '& .ms-Checkbox-label': {
        alignItems: 'start',
      },
    },
    defaultTitle: {
      extend: commonFont,
      lineHeight: '24px',
      ...titleFont,
    },
    nonAccordionTitle: {
      extend: commonFont,
      lineHeight: '20px',
      ...subTitleFont,
      display: 'flex',
      '& .title': {
        marginRight: '6px',
      },
      marginBottom: '5px',
    },
    bodyText: {
      extend: commonFont,
      lineHeight: '20px',
      ...plainTextFont,
    },
    errorText: {
      extend: commonFont,
      lineHeight: '20px',
      ...plainTextFont,
      color: color.errorAlertColor,
      marginLeft: '20px',
    },
    inactiveText: {
      color: '#a19f9d',
    },
    rowContainer: {
      display: 'flex',
      paddingTop: '6px',
      paddingBottom: '6px',
      '& .url-field': {
        marginLeft: '15px',
      },
    },
    tagDialogText: {
      '& .btn-link': {
        color: '#0078d4 !important',
        '&:focus, &:hover, &:active': {
          textDecoration: 'underline',
        },
      },
    },
    scopeEditor: {
      width: 800,

      '& .sharing-scope-dblist': {
        '& .sharing-scope-tree-view': {
          border: 'grey solid 1px',
          padding: '10px',
          overflow: 'auto',
          height: '350px',
        },

        '& .hierarchy-tree': {
          minHeight: '200px',
        },

        '& .sharing-scope-tree-view__search-box': {
          marginBottom: '15px',
        },

        '& .glyph-caret-right, .glyph-caret-down': {
          '&:before': {
            verticalAlign: 'middle',
          },
        },

        '& .glyph-none': {
          '&::before': {
            content: '\\2122',
            color: 'transparent !important',
            verticalAlign: 'middle',
          },
        },
      },
    },
  });
};
